import { Stack, Typography } from '@mui/joy';

export function RecipeDetails({ recipe, nutrition, level = 'title-xs' }) {  
  return (
    <Stack direction="row" gap={1} alignItems="center">      
      {nutrition && <Typography level={level}>{nutrition.perServing.kcal} kcal</Typography>}
    </Stack>
  );
}